import DatabaseModel from './DatabaseModelOffline.js';

var Provincia = Object.create(DatabaseModel);

Provincia.model = 'provincias';

export default Provincia;